import { render } from "./BusyIndicator.vue?vue&type=template&id=12ea4c64&scoped=true"
import script from "./BusyIndicator.vue?vue&type=script&lang=js"
export * from "./BusyIndicator.vue?vue&type=script&lang=js"

import "./BusyIndicator.vue?vue&type=style&index=0&id=12ea4c64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\ArchiV2\\LP-MyFirstBusiness\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ea4c64"]])

export default __exports__